// ============================================================
// diagnostic-config.js
// Configuration du questionnaire et des pondérations
//
// Piliers physiologiques :
//   B — Barrière & confort
//   R — Renouvellement & éclat
//   S — Séborégulation
//   F — Fermeté
//   O - Equilibre oxydatif
// Questions Q1-Q11 : contribuent aux scores physiologiques
// Questions Q12-Q17 : personnalisent la routine uniquement
// ============================================================


const SEUIL_SIGNIFICATIF = 4


const QUESTIONS = [

  // Q1 — Signes généraux (obligatoire, pivot)
  {
    id: 'q1',
    label: 'Quels signes observez-vous sur votre peau ?',
    instruction: 'Plusieurs réponses possibles.',
    type: 'checkbox',
    required: true,
    options: [
      { id: 'q1_sensible',      label: 'Ma peau est sensible ou réactive.',                         scores: { B:2, S:0, R:0, O:0, F:0 } },
      { id: 'q1_seche',         label: 'Ma peau est sèche ou déshydratée.',                         scores: { B:2, S:0, R:0, O:0, F:0 } },
      { id: 'q1_brille',        label: 'Ma peau brille facilement.',                                scores: { B:0, S:2, R:0, O:0, F:0 } },
      { id: 'q1_imperfections', label: 'J\'ai des imperfections (boutons, points noirs...).',       scores: { B:0, S:2, R:0, O:0, F:0 } },
      { id: 'q1_terne',         label: 'Mon teint parait terne ou fatigué.',             scores: { B:0, S:0, R:1, O:1, F:0 } },
      { id: 'q1_taches',        label: 'J\'observe des taches pigmentaires.',                       scores: { B:0, S:0, R:1, O:2, F:0 } },
      { id: 'q1_rides',         label: 'J\'observe des rides ou des ridules.',                      scores: { B:0, S:0, R:1, O:1, F:1 } },
      { id: 'q1_fermete',       label: 'Ma peau manque de fermeté ou de tonicité.',                scores: { B:0, S:0, R:0, O:0, F:2 } },
      { id: 'q1_rien',          label: 'Rien de particulier.',                                      scores: { B:0, S:0, R:0, O:0, F:0 }, exclusive: true },
    ]
  },

  // Q2 — Sensibilité (conditionnelle : q1_sensible)
  {
    id: 'q2',
    condition: { question: 'q1', answer: 'q1_sensible' },
    label: 'Parmi les affirmations suivantes, lesquelles correspondent à votre peau ?',
    instruction: 'Plusieurs réponses possibles.',
    type: 'checkbox',
    options: [
      { id: 'q2_rougeurs',    label: 'Ma peau présente souvent des rougeurs.',                                          scores: { B:3, S:0, R:0, O:0, F:0 } },
      { id: 'q2_cosmetiques', label: 'Ma peau réagit facilement à certains cosmétiques.',                               scores: { B:3, S:0, R:0, O:0, F:0 } },
      { id: 'q2_froid',       label: 'Ma peau réagit facilement au froid, au vent ou aux changements de température.',  scores: { B:2, S:0, R:0, O:0, F:0 } },
      { id: 'q2_stress',      label: 'Le stress ou la fatigue rendent ma peau plus réactive.',                          scores: { B:1, S:0, R:0, O:0, F:0 } },
      { id: 'q2_aucune',      label: 'Aucune de ces situations.',                                                       scores: { B:0, S:0, R:0, O:0, F:0 }, exclusive: true },
    ]
  },

  // Q3 — Barrière & confort (obligatoire)
  {
    id: 'q3',
    label: 'Parmi les situations suivantes, lesquelles observez-vous régulièrement ?',
    instruction: 'Plusieurs réponses possibles.',
    type: 'checkbox',
    required: true,
    options: [
      { id: 'q3_tiraillements', label: 'Ma peau tiraille après le nettoyage.',                        scores: { B:3, S:0, R:0, O:0, F:0 } },
      { id: 'q3_zones_seches',  label: 'Ma peau présente des zones sèches ou qui desquament.',        scores: { B:3, S:0, R:1, O:0, F:0 } },
      { id: 'q3_souplesse',     label: 'Ma peau manque de souplesse.',                                scores: { B:2, S:0, R:1, O:0, F:1 } },
      { id: 'q3_maquillage',    label: 'Mon maquillage marque facilement les zones sèches.',          scores: { B:2, S:0, R:1, O:0, F:0 } },
      { id: 'q3_aucune',        label: 'Aucune de ces situations.',                                   scores: { B:0, S:0, R:0, O:0, F:0 }, exclusive: true },
    ]
  },

  // Q4 — Brillance (conditionnelle : q1_brille)
  {
    id: 'q4',
    condition: { question: 'q1', answer: 'q1_brille' },
    label: 'Lorsque votre peau brille, où cela se produit-il le plus souvent ?',
    instruction: 'Plusieurs réponses possibles.',
    type: 'checkbox',
    options: [
      { id: 'q4_visage',   label: 'Sur l\'ensemble du visage.',                         scores: { B:0, S:3, R:0, O:0, F:0 } },
      { id: 'q4_zoneT',    label: 'Principalement sur le front, le nez et le menton.',  scores: { B:0, S:2, R:0, O:0, F:0 } },
      { id: 'q4_localise', label: 'Seulement sur quelques zones localisées.',           scores: { B:0, S:1, R:0, O:0, F:0 } },
      { id: 'q4_pores',    label: 'Je remarque également des pores dilatés.',           scores: { B:0, S:3, R:0, O:0, F:0 } },
      { id: 'q4_aucune',   label: 'Aucune de ces situations.',                          scores: { B:0, S:0, R:0, O:0, F:0 }, exclusive: true },
    ]
  },

  // Q5 — Imperfections (conditionnelle : q1_imperfections)
  {
    id: 'q5',
    condition: { question: 'q1', answer: 'q1_imperfections' },
    label: 'Parmi les affirmations suivantes, lesquelles correspondent à vos imperfections ?',
    instruction: 'Plusieurs réponses possibles.',
    type: 'checkbox',
    options: [
      { id: 'q5_points_noirs',   label: 'J\'ai des points noirs.',                                         scores: { B:0, S:5, R:1, O:0, F:0 } },
      { id: 'q5_inflammatoires', label: 'J\'ai des boutons rouges ou inflammatoires.',                     scores: { B:0, S:4, R:2, O:0, F:0 } },
      { id: 'q5_zoneT',          label: 'Mes imperfections sont situées principalement dans la zone T.',   scores: { B:0, S:2, R:0, O:0, F:0 } },
      { id: 'q5_visage',         label: 'Mes imperfections concernent l\'ensemble du visage.',             scores: { B:0, S:4, R:1, O:1, F:0 } },
      { id: 'q5_aucune',         label: 'Aucune de ces situations.',                                       scores: { B:0, S:0, R:0, O:0, F:0 }, exclusive: true },
    ]
  },

  // Q6 — Éclat & texture (conditionnelle : q1_terne)
  {
    id: 'q6',
    condition: { question: 'q1', answer: 'q1_terne' },
    label: 'Parmi les affirmations suivantes, lesquelles correspondent à votre peau ?',
    instruction: 'Plusieurs réponses possibles.',
    type: 'checkbox',
    options: [
      { id: 'q6_terne',   label: 'Mon teint parait moins lumineux, même quand je suis reposé(e).',                                   scores: { B:1, S:0, R:2, O:2, F:0 } },
      { id: 'q6_grain',   label: 'La texture de ma peau paraît moins lisse ou moins régulière.',   scores: { B:1, S:1, R:3, O:2, F:0 } },
   { id: 'q6_rebondi', label: 'Ma peau parait moins tonique et retrouve moins facilement son aspect frais et rebondi.',                                 scores: { B:1, S:0, R:1, O:1, F:2 } },
      { id: 'q6_aucune',  label: 'Aucune de ces situations.',                                                    scores: { B:0, S:0, R:0, O:0, F:0 }, exclusive: true },
    ]
  },

  // Q7 — Taches pigmentaires (conditionnelle : q1_taches)
  {
    id: 'q7',
    condition: { question: 'q1', answer: 'q1_taches' },
    label: 'Parmi les affirmations suivantes, lesquelles correspondent à vos taches pigmentaires ?',
    instruction: 'Plusieurs réponses possibles.',
    type: 'checkbox',
    options: [
      { id: 'q7_quelques',  label: 'J\'ai une ou quelques taches bien délimitées.',        scores: { B:0, S:0, R:1, O:1, F:0 } },
      { id: 'q7_nombreuses',label: 'J\'ai de nombreuses petites taches brunes.',           scores: { B:0, S:0, R:1, O:2, F:0 } },
      { id: 'q7_etendue',   label: 'Mes taches forment une zone pigmentée plus étendue.',  scores: { B:0, S:0, R:2, O:2, F:0 } },
      { id: 'q7_aucune',    label: 'Aucune de ces situations.',                            scores: { B:0, S:0, R:0, O:0, F:0 }, exclusive: true },
    ]
  },

  // Q8 — Apparition des taches (conditionnelle : q7_nombreuses ou q7_etendue)
  {
    id: 'q8',
    condition: { question: 'q7', answer: ['q7_nombreuses', 'q7_etendue'] },
    label: 'Comment ces taches sont-elles apparues ?',
    instruction: 'Une seule réponse possible.',
    type: 'radio',
    options: [
      { id: 'q8_progressive', label: 'Progressivement au fil des années.',        scores: { B:0, S:0, R:1, O:2, F:0 } },
      { id: 'q8_rapide',      label: 'Sur une période relativement courte.',      scores: { B:0, S:0, R:1, O:0, F:0 } },
      { id: 'q8_sais_pas',    label: 'Je ne sais pas.',                           scores: { B:0, S:0, R:0, O:0, F:0 } },
    ]
  },

  // Q9 — Mode de vie (obligatoire)
  {
    id: 'q9',
    label: 'Parmi les affirmations suivantes, lesquelles vous correspondent ?',
    instruction: 'Plusieurs réponses possibles.',
    type: 'checkbox',
    required: true,
    options: [
      { id: 'q9_soleil',  label: 'Je m\'expose régulièrement au soleil ou je me suis beaucoup exposé(e) par le passé.',  scores: { B:0, S:0, R:2, O:4, F:2 } },
      { id: 'q9_tabac',   label: 'Je fume ou j\'ai fumé.',                                                               scores: { B:1, S:0, R:2, O:4, F:3 } },
      { id: 'q9_sommeil', label: 'Je manque souvent de sommeil.',                                                        scores: { B:1, S:0, R:1, O:3, F:1 } },
      { id: 'q9_stress',  label: 'Je suis souvent stressé(e) ou fatigué(e).',                                           scores: { B:1, S:1, R:0, O:3, F:1 } },
      { id: 'q9_aucune',  label: 'Aucune de ces situations.',                                                            scores: { B:0, S:0, R:0, O:0, F:0 }, exclusive: true },
    ]
  },

  // Q10 — Rides & ridules (conditionnelle : q1_rides)
  {
    id: 'q10',
    condition: { question: 'q1', answer: 'q1_rides' },
    label: 'Parmi les affirmations suivantes, lesquelles correspondent à vos rides ou ridules ?',
    instruction: 'Plusieurs réponses possibles.',
    type: 'checkbox',
    options: [
      { id: 'q10_ridules',    label: 'J\'observe de fines ridules qui peuvent s\'atténuer après un soin.',                  scores: { B:1, S:0, R:2, O:0, F:1 } },
      { id: 'q10_localisees', label: 'J\'observe surtout quelques rides localisées (front, sourcils, contour des yeux).',   scores: { B:0, S:0, R:3, O:0, F:2 } },
      { id: 'q10_marquees',   label: 'J\'observe des rides plus nombreuses ou marquées sur plusieurs zones du visage.',     scores: { B:0, S:0, R:2, O:2, F:3 } },
      { id: 'q10_aucune',     label: 'Aucune de ces situations.',                                                           scores: { B:0, S:0, R:0, O:0, F:0 }, exclusive: true },
    ]
  },

  // Q11 — Fermeté (conditionnelle : q1_fermete)
  {
    id: 'q11',
    condition: { question: 'q1', answer: 'q1_fermete' },
    label: 'Parmi les affirmations suivantes, lesquelles correspondent le mieux à ce que vous observez ?',
    instruction: 'Plusieurs réponses possibles.',
    type: 'checkbox',
    options: [
      { id: 'q11_rebondi',     label: 'Ma peau paraît moins rebondie qu\'auparavant.',              scores: { B:0, S:0, R:1, O:1, F:2 } },
      { id: 'q11_ovale',       label: 'Les contours de mon visage me paraissent moins nets.',       scores: { B:0, S:0, R:0, O:1, F:3 } },
      { id: 'q11_elastique',   label: 'Ma peau semble moins ferme ou moins élastique.',          scores: { B:0, S:0, R:0, O:1, F:2 } },
      { id: 'q11_relachement', label: 'J\'observe un relâchement au niveau des joues, de l\'ovale du visage ou du cou.',  scores: { B:0, S:0, R:0, O:2, F:3 } },
      { id: 'q11_aucune',      label: 'Aucune de ces situations.',                                  scores: { B:0, S:0, R:0, O:0, F:0 }, exclusive: true },
    ]
  },

  // Q12 – Maquillage
  {
    id: 'q12',
    label: 'Vous maquillez-vous régulièrement ?',
    instruction: 'Une seule réponse possible.',
    type: 'radio',
    options: [
     { id: 'q12_jamais',     label: 'Non, jamais ou presque.',                                          scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q12_occasion',   label: 'Oui, occasionnellement.',                                          scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q12_semaine',    label: 'Oui, plusieurs fois par semaine.',                                 scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q12_quotidien',  label: 'Oui, presque tous les jours.',                                     scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q12_waterproof', label: 'Oui, avec du mascara waterproof ou du maquillage longue tenue.',   scores: { B:0, S:0, R:0, O:0, F:0 } },
    ]
  },

  // Q13 – Nettoyage avec maquillage (conditionnelle : se maquille)
  {
    id: 'q13',
    condition: { question: 'q12', answer: ['q12_occasion', 'q12_semaine', 'q12_quotidien', 'q12_waterproof'] },
    label: 'Le soir, comment nettoyez-vous et démaquillez-vous généralement votre peau ?',
    instruction: 'Une seule réponse possible.',
    type: 'radio',
    options: [
     { id: 'q13_sans_rincage',    label: 'J\'utilise uniquement un produit sans rinçage (eau micellaire, lait...).',  scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q13_avec_rincage',    label: 'J\'utilise un nettoyant-démaquillant à rincer.',                            scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q13_double',          label: 'J\'utilise successivement un démaquillant puis un nettoyant.',              scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q13_selon_jours',     label: 'Cela dépend des jours.',                                                    scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q13_pas_systematique',label: 'Je ne nettoie ou ne démaquille pas systématiquement ma peau.',              scores: { B:0, S:0, R:0, O:0, F:0 } },
    ]
  },

  // Q14 – Nettoyage sans maquillage (conditionnelle : ne se maquille pas)
  {
    id: 'q14',
    condition: { question: 'q12', answer: ['q12_jamais'] },
    label: 'Le soir, comment nettoyez-vous généralement votre visage ?',
    instruction: 'Une seule réponse possible.',
    type: 'radio',
    options: [
     { id: 'q14_pas_nettoyage', label: 'Je n\'effectue généralement pas de nettoyage.',  scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q14_eau',           label: 'Je rince simplement mon visage à l\'eau.',        scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q14_sans_rincage',  label: 'J\'utilise un nettoyant sans rinçage.',           scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q14_avec_rincage',  label: 'J\'utilise un nettoyant à rincer.',               scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q14_selon_jours',   label: 'Cela dépend des jours.',                          scores: { B:0, S:0, R:0, O:0, F:0 } },
    ]
  },

  // Q15 – Préférence de nettoyage (tout le monde)
  {
    id: 'q15',
    label: 'Pour votre nettoyage ou votre démaquillage, que préférez-vous ?',
    instruction: 'Une seule réponse possible.',
    type: 'radio',
    options: [
     { id: 'q15_sans_rincage',  label: 'Un produit sans rinçage.',       scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q15_avec_rincage',  label: 'Un produit à rincer.',           scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q15_les_deux',      label: 'Les deux me conviennent.',       scores: { B:0, S:0, R:0, O:0, F:0 } },
    ]
  },

  // Q16 – Mode de vie
  {
    id: 'q16',
    label: 'Parmi les affirmations suivantes, laquelle correspond le mieux à votre quotidien ?',
    instruction: 'Une seule réponse possible.',
    type: 'radio',
    options: [
     { id: 'q16_voyage',       label: 'Je voyage ou me déplace souvent et je recherche une routine facile à emporter.',  scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q16_sport',        label: 'Je pratique régulièrement une activité sportive.',                                 scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q16_manque_temps', label: 'Je manque souvent de temps et je préfère une routine rapide.',                    scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q16_prend_temps',  label: 'J\'aime prendre le temps de réaliser une routine complète.',                      scores: { B:0, S:0, R:0, O:0, F:0 } },
     { id: 'q16_aucun',        label: 'Aucun de ces profils en particulier.',                                             scores: { B:0, S:0, R:0, O:0, F:0 } },
    ]
  },

  // Q17 – Soin du corps
  {
    id: 'q17',    
    label: 'Et concernant la peau de votre corps... Lequel de ces besoins vous correspond le mieux ?',
    instruction: 'Vous pouvez sélectionner plusieurs réponses.',
    type: 'checkbox',
    options: [
      { id: 'seche',        label: 'Ma peau est souvent sèche ou rugueuse.' },
      { id: 'tiraillement', label: 'Ma peau tiraille après la douche.' },
      { id: 'reconfort',    label: 'Ma peau a besoin de réconfort après une exposition au soleil, au vent, au froid ou après la baignade.' },
      { id: 'souplesse',    label: 'Je souhaite retrouver une peau plus souple et confortable.' },
      { id: 'aucun',        label: 'Je n\'ai pas de besoin particulier.', exclusive: true }
    ]
  }
  
]
const PRODUITS = [
  { id: 'cocoon-creme',       handle: 'creme-hydratante-confort-niacinamide-panthenol',          image: 'https://cdn.shopify.com/s/files/1/0975/8602/0726/files/kosmorebi-creme-hydratante-cocoon-niacinamide-panthenol.png?v=1781263377',      title: 'Crème Cocoon',                  category: 'soinsVisage',        scores: { B: 5, R: 2, S: 1, F: 3 } },
  { id: 'peps-creme',         handle: 'creme-vitaminee-ace-50ml',                                image: 'https://cdn.shopify.com/s/files/1/0975/8602/0726/files/kosmorebi-creme-vitaminee-peps-vitamines-ace.png?v=1781263378',                  title: 'Crème PEP\'S',                  category: 'soinsVisage',        scores: { B: 2, R: 5, S: 2, F: 5 } },
  { id: 'peps-masque',        handle: 'masque-3en1-a-l-orange-masque-gommage-nettoyant-50ml',    image: 'https://cdn.shopify.com/s/files/1/0975/8602/0726/files/kosmorebi-masque-3-en-1-peps-orange-vitamine-c.png?v=1781263375',                title: 'Masque PEP\'S',                 category: 'soinsHebdomadaires', scores: { B: 2, R: 5, S: 3, F: 3 } },
  { id: 'pure-peeling',       handle: 'peeling-purifiant-a-l-acide-salicylique-2',               image: 'https://cdn.shopify.com/s/files/1/0975/8602/0726/files/kosmorebi-peeling-purifiant-pure-acide-salicylique-2.png?v=1781263375',          title: 'Peeling PURE',                  category: 'soinsHebdomadaires', scores: { B: 1, R: 5, S: 5, F: 1 } },
  { id: 'velvet-mousse',      handle: 'mousse-micellaire-demaquillante-a-la-rose-de-damas-150ml',image: 'https://cdn.shopify.com/s/files/1/0975/8602/0726/files/kosmorebi-mousse-micellaire-velvet-eclat-rose-damas.png?v=1781263377',            title: 'Mousse Velvet',                 category: 'nettoyage',          scores: { B: 4, R: 3, S: 1, F: 3 } },
  { id: 'peps-mousse',        handle: 'mousse-micellaire-demaquillante-vitaminee-150ml',          image: 'https://cdn.shopify.com/s/files/1/0975/8602/0726/files/kosmorebi-mousse-micellaire-vitaminee-peps.png?v=1781263378',                    title: 'Mousse PEP\'S',                 category: 'nettoyage',          scores: { B: 3, R: 4, S: 3, F: 4 } },
  { id: 'pure-oleogel',       handle: 'oleogel-demaquillant-50ml',                               image: 'https://cdn.shopify.com/s/files/1/0975/8602/0726/files/kosmorebi-oleogel-demaquillant-pure.png?v=1781263376',                           title: 'Oléogel PURE',                  category: 'nettoyage',          scores: { B: 4, R: 2, S: 4, F: 1 } },
  { id: 'cocoon-baume-corps', handle: 'baume-reparateur-corps-cocoon-amande-karite-120ml',        image: 'https://cdn.shopify.com/s/files/1/0975/8602/0726/files/kosmorebi-baume-corps-cocoon-karite-amande-douce.png?v=1781263375',              title: 'Baume Réparateur Corps Cocoon', category: 'corps',              scores: { B: 5, R: 2, S: 1, F: 2 } }
]
